import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default class LocalLoading extends React.Component {
    render() {
        return (
            <div className="local-loader tac">
                <FontAwesomeIcon icon={faSpinner} size="2x" spin />
                <p>{this.props.text}</p>
            </div>
        )
    }
}
